import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFuncionIns = async (credentials, data) => {
  const body = {
    service: "RNHFuncionIns",
    params: {
      rnhFuncionNombre: data?.nombre || null,
      rnhFuncionCod: data?.cod|| null,
      // Opcional: sin agrupamiento viaja null. El Number() es porque el <select>
      // entrega string — ver README del modulo.
      rnhFuncionAgrupamientoId: Number(data?.agrupamientoId) || null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));
};
